const pages = {
  sendCode: 'send-code',
  signIn: 'sign-in',
  appointmentSchedule: 'appointment-schedule',
  scheduleConfirmed: 'schedule-confirmed',
  rescheduleCancel: 'reschedule-cancel',
  cancelConfirmed: 'cancel-confirmed',
};

export default pages;
